<ng-http-loader
    [spinner]="spinkit.skSpinnerPulse" [filteredUrlPatterns]="['getActiveDowntimeWindow']">
</ng-http-loader>
<router-outlet></router-outlet>
<p-dialog header="Confirmation" [(visible)]="displayBasic"  [autoZIndex]="true" [modal]="true">
    <p>Your session will expire in {{counter}} seconds.</p>
    <br>
    <p>Click on continue to stay in application  else you will be logout.</p>
    <br>
    <div class="col form-footer">
        <button pButton type="button" class="ey-button-dark me-2 mt-0 session-dialog-btn"  (click)="continue()">
          Continue
        </button>
        <button  pButton class="ey-secondary-dark me-2 mt-0 session-dialog-btn" type="submit" (click)="cancel()">
            Cancel
        </button>           
    </div>
</p-dialog>  
<p-confirmDialog></p-confirmDialog>